import { type ElementType } from 'react';
import { type TypographyVariant } from './types';

export const variantClasses: Record<TypographyVariant, string> = {
  'title-large': 'font-chronicle-display text-mobile-title-large md:text-title-large',
  'title-medium': 'font-chronicle-display text-mobile-title-medium md:text-title-medium',
  'title-small': 'font-chronicle-display text-mobile-title-small md:text-title-small',
  'section-title-xlarge-bold':
    'font-semibold text-mobile-section-title-xlarge md:text-section-title-xlarge',
  'section-title-xlarge': 'text-mobile-section-title-xlarge md:text-section-title-xlarge',
  'section-title-large-bold':
    'font-semibold text-mobile-section-title-large md:text-section-title-large',
  'section-title-large': 'text-mobile-section-title-large md:text-section-title-large',
  'section-title-medium-bold':
    'font-semibold text-mobile-section-title-medium md:text-section-title-mediu',
  'section-title-medium': 'text-mobile-section-title-medium md:text-section-title-medium',
  'section-title-small-bold':
    'font-semibold text-mobile-section-title-small md:text-section-title-small',
  'section-title-small': 'text-mobile-section-title-small md:text-section-title-small',
  'text-large-bold': 'font-semibold text-large',
  'text-large': 'text-large',
  'text-medium-bold': 'font-semibold text-medium',
  'text-medium': 'text-medium',
  'text-xsmall-bold': 'font-semibold text-xsmall',
  'text-xsmall': 'text-xsmall',
  'text-xxsmall-bold': 'font-semibold text-xxsmall',
  'text-xxsmall': 'text-xxsmall',
  'text-tiny-bold': 'font-semibold text-tiny',
  'text-tiny': 'text-tiny',
  'accent-large': 'font-semibold uppercase text-accent-large',
  'accent-medium': 'font-semibold uppercase text-accent-medium',
  'accent-small': 'font-medium uppercase text-accent-small',
};

export const defaultTags: Record<TypographyVariant, ElementType> = {
  'title-large': 'h1',
  'title-medium': 'h2',
  'title-small': 'h3',
  'section-title-xlarge-bold': 'h4',
  'section-title-xlarge': 'h4',
  'section-title-large-bold': 'h5',
  'section-title-large': 'h5',
  'section-title-medium-bold': 'h6',
  'section-title-medium': 'h6',
  'section-title-small-bold': 'h6',
  'section-title-small': 'h6',
  'text-large-bold': 'span',
  'text-large': 'span',
  'text-medium-bold': 'span',
  'text-medium': 'span',
  'text-xsmall-bold': 'span',
  'text-xsmall': 'span',
  'text-xxsmall-bold': 'span',
  'text-xxsmall': 'span',
  'text-tiny-bold': 'span',
  'text-tiny': 'span',
  'accent-large': 'span',
  'accent-medium': 'span',
  'accent-small': 'span',
};
